import { render, staticRenderFns } from "./ResearchersHome.vue?vue&type=template&id=20d289d8&scoped=true&"
import script from "./ResearchersHome.vue?vue&type=script&lang=js&"
export * from "./ResearchersHome.vue?vue&type=script&lang=js&"
import style0 from "./ResearchersHome.vue?vue&type=style&index=0&id=20d289d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d289d8",
  null
  
)

export default component.exports